import * as types from './types';
import { tabEnum } from '../../helpers/SiteSetupConstants';

const INITIAL_STATE = {
  selectedTab: tabEnum.SITE_DETAILS,
  isGridLoading: false,
  showLicensed: true,
  showActive: true,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.SITESETUP_SET_SELECTED_TAB:
      return {
        ...state,
        selectedTab: action.payload,
      };

    case types.SITESETUP_GRID_LOADING:
      return {
        ...state,
        isGridLoading: action.payload,
      };

    case types.SITESETUP_SET_SHOW_ISLICENSED:
      return {
        ...state,
        showLicensed: action.payload,
      };
    case types.SITESETUP_SET_SHOW_ISACTIVE:
      return {
        ...state,
        showActive: action.payload,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/sitesetup/state/settings/reducer.js